<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div v-for="(dashboard, i) in 風景區" :key="i">
        <div class="row">
          <div class="h3">
            {{ dashboard.name }}
            <a href="#" class="btn btn-info">手動刷新</a>
          </div>
        </div>

        <!--看板-->
        <div class="row">
          <div class="col-6 col-md-3" v-for="(point, i) in 看板" :key="i">
            <div class="bg-card text-center">
              <p class="title text-primary">
                <i :class="point.icon"></i>{{ point.name }}
              </p>
              <p class="contant">{{ point.conent }}</p>
            </div>
          </div>
        </div>
        <!--即時車況-->
        <div class="row">
          <div class="col-12">
            <div class="bg-card">
              <p class="title text-primary">
                <i class="fa fa-chart-bar mr-3"></i>即時車況
              </p>
              <div class="row text-center ">
                <div class="col-12 col-md-4" v-for="(point, i) in 即時車況" :key="i">
                  <p class="h5 bg-primary text-white p-2">
                    <i :class="point.icon"></i>{{ point.name }}
                  </p>
                  <div class="row">
                    <div class="col-12 col-xl-7">
                      <div id="chart">
                        <apexchart
                          type="pie"
                          width="250"
                          :options="chartOptions"
                          :series="series"
                        ></apexchart>
                      </div>
                    </div>
                    <div class="col-12 col-xl-5 h6">
                      <p>進場：10</p>
                      <p>空位：190</p>
                      <p>乘載率：5%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--即時天氣-->
        <div class="row">
          <div class="col-12">
            <div class="bg-card">
              <p class="title text-primary">
                <i class="fa fa-sun mr-3"></i>氣候概況
              </p>
              <div class="row m-0 text-center h6">
                <div
                  class="col-6 col-md-2"
                  v-for="(point, i) in 氣候概況"
                  :key="i"
                >
                  <p class="text-center h5 bg-primary text-white p-2">
                    {{ point.name }}
                  </p>
                  {{ point.num }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--即時廁所使用-->
        <div class="row">
          <div class="col-12">
            <div class="bg-card">
              <p class="title text-primary">
                <i class="fas fa-male"></i
                ><i class="fas fa-female mr-3"></i>廁所使用狀況
              </p>
              <div class="row">
                <div
                  class="col-12 col-md-4"
                  v-for="(point, i) in 廁所狀況"
                  :key="i"
                >
                  <p class="text-center h5 bg-primary text-white p-2">
                    {{ point.name }}
                  </p>
                  <table class="table table-bordered">
                    <tr class="text-center">
                      <td class="h5 p-4">
                        <i class="fas fa-male fa-2x text-primary mr-4"></i
                        >{{ point.male }}
                      </td>
                      <td class="h5 p-4">
                        <i class="fas fa-female fa-2x text-danger mr-4"></i
                        >{{ point.female }}
                      </td>
                      <td class="h5 p-4">
                        <i class="fas fa-wheelchair fa-2x text-success mr-4"></i
                        >{{ point.other }}
                      </td>
                    </tr>
                  </table>
                </div>               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "Home",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      風景區: [{ name: "石梯坪" }, { name: "八仙洞" }, { name: "三仙台" }],
      看板: [
        { name: "在園人數", icon: "fa fa-users mr-3", conent: "85人" },
        { name: "本日總人數", icon: "fa fa-users mr-3", conent: "285人" },
        { name: "在園車輛", icon: "fa fa-car mr-3", conent: "10" },
        { name: "本日總車輛", icon: "fa fa-car mr-3", conent: "28" },
      ],
      即時車況: [
        { name: "大型車", icon: "fa fa-bus mr-3" },
        { name: "小型車", icon: "fa fa-car mr-3" },
        { name: "機車", icon: "fa fa-motorcycle mr-3" },
      ],
      氣候概況: [
        { name: "天氣", num: "晴", point: true, time: "2022/2/24 上午10:00" },
        { name: "氣溫", num: "24 ℃", point: true, time: "2022/2/24 上午10:00" },
        { name: "雨量", num: "0 mm", point: true, time: "2022/2/24 上午10:00" },
        { name: "濕度", num: "20 %", point: true, time: "2022/2/24 上午10:00" },
        {
          name: "風速",
          num: "3 m/s",
          point: true,
          time: "2022/2/24 上午10:00",
        },
        { name: "風力", num: "7級", point: true, time: "2022/2/24 上午10:00" },
        { name: "陣風", num: "2級", point: false, time: "2022/2/24 上午10:00" },
        {
          name: "浪高",
          num: "2公尺",
          point: false,
          time: "2022/2/24 上午10:00",
        },
        {
          name: "長浪",
          num: "2公尺",
          point: false,
          time: "2022/2/24 上午10:00",
        },
        { name: "地震", num: "2級", point: false, time: "2022/2/24 上午10:00" },
        { name: "颱風", num: "2級", point: false, time: "2022/2/24 上午10:00" },
        {
          name: "豪雨特報",
          num: "無",
          point: false,
          time: "2022/2/24 上午10:00",
        },
      ],
      廁所狀況: [
        { name: "遊客中心", male: "5", female: "5", other: "0" },
        { name: "遊客中心B1", male: "5", female: "5", other: "0" },
        { name: "遊客中心外圍", male: "5", female: "5", other: "0" },
        { name: "停車場", male: "5", female: "5", other: "0" },
      ],
      series: [10, 190],
      chartOptions: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["進場", "空位"],
        dataLabels: {
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: ["#28a745", "#ffc107"],
      },
    };
  },

  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>
